import React from 'react';
import Contactform from './Contactform';
import ContactDetails from './ContactDetails';

const ContactUs = () =>{
    return (
        <>
        <div className='cadContactForm'>
                <div className='container'>
                    <h2>HAVE A QUESTION?</h2>
                    <div className='row cad-contact-form-align'>
                        <div className='cadContactFormContent cadServicesListContent cad-contact-detailsCols col-6'>
                            <span>Get In Touch</span>
                            <p>Please tell how can we help you? We are more than happy to solve all your queries.</p>
                            <div className='cad-contact-detailsCols-inner'>
                                <ContactDetails />
                            </div>
                        </div>
                        <Contactform />
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactUs;